import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={10} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <rect width="10" height="10" rx="1" fill="#81BC3F" />
    <g clipPath="url(#clip0_5582_119932)">
      <path
        d="M2.14307 5.71205L4.22099 7.85491C5.19878 5.04613 6.0131 3.81361 7.85735 2.14062"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5582_119932">
        <rect width="8" height="8" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const StatusDelivered = memo(ForwardRef);
export default StatusDelivered;
